/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundingRequestPayoutGroupItemDto
 */
export interface FundingRequestPayoutGroupItemDto {
  /**
   *
   * @type {string}
   * @memberof FundingRequestPayoutGroupItemDto
   */
  fundingRequestId: string;
  /**
   *
   * @type {number}
   * @memberof FundingRequestPayoutGroupItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof FundingRequestPayoutGroupItemDto
   */
  comment: string | null;
}

export function FundingRequestPayoutGroupItemDtoFromJSON(json: any): FundingRequestPayoutGroupItemDto {
  return FundingRequestPayoutGroupItemDtoFromJSONTyped(json, false);
}

export function FundingRequestPayoutGroupItemDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FundingRequestPayoutGroupItemDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundingRequestId: json["fundingRequestId"],
    amount: json["amount"],
    comment: json["comment"],
  };
}

export function FundingRequestPayoutGroupItemDtoToJSON(value?: FundingRequestPayoutGroupItemDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundingRequestId: value.fundingRequestId,
    amount: value.amount,
    comment: value.comment,
  };
}
